export const ifElseStatementSpec = {
  content: '',
  group: 'block',
  marks: '',
  atom: true,
  attrs: {
    type: {
      default: 'ifElseStatement'
    },
    fallbackBlocks: {},
    predicatesBlocksPairs: {}
  },
  toDOM() {
    return ['div'];
  }
};